



import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { FetchData, Toast } from "../../customHooks/customHooks";
import { CALLS_MANAGE_COLUMN_PERMISSON_GET_URL, CALLS_MANAGE_COLUMN_PERMISSON_SET_URL } from "../../api";

// -- Async Thunk to Get User Profile --
export const GetAllCallPermission = createAsyncThunk('CallPerMission', async (id, { rejectWithValue }) => {

    try {
        const response = await FetchData(CALLS_MANAGE_COLUMN_PERMISSON_GET_URL, {roleId : id});

        if (!response) throw new Error("No response received");

        if (response.status === 200) {
            let { data } = response.data
            if(data) {
                return { status: 200, data } // ✅ Return the actual user profile data
            } else {
                return { status: 400, data } // ✅ Return the actual user profile data
            }
        } else if (response.status === 401) {
            return rejectWithValue("Unauthorized");
        } else {
            return rejectWithValue("Failed to fetch user profile");
        }
    } catch (err) {
        console.log("Error fetching user profile:", err);
        return rejectWithValue(err.message || "Something went wrong");
    }
});

// -- Slice --
const GetCallSPermissionSlice = createSlice({
    name: 'AllPermissionCall',
    initialState: {
        AllPermissionCall: [],
        loading: false,
        error: null
    },
    extraReducers: (builder) => {
        builder
            .addCase(GetAllCallPermission.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(GetAllCallPermission.fulfilled, (state, action) => {
                state.AllPermissionCall = action.payload; // ✅ Store fetched profile
                state.loading = false;
            })
            .addCase(GetAllCallPermission.rejected, (state, action) => {
                state.error = action.payload || action.error.message;
                state.loading = false;
            });
    }
});



export const SetCallPermission = createAsyncThunk('CreateCallpermission', async (body, { rejectWithValue }) => {

    try {
        const response = await FetchData(CALLS_MANAGE_COLUMN_PERMISSON_SET_URL, body);

        if (!response) throw new Error("No response received");

        if (response.status === 200) {
            Toast('success', response?.data?.apiStatus?.statusMessage)
            return 'ok'
        } else if (response.status === 401) {
            return rejectWithValue("Unauthorized");
        } else {
            return rejectWithValue("Failed to fetch user profile");
        }
    } catch (err) {
        console.log("Error fetching user profile:", err);
        return rejectWithValue(err.message || "Something went wrong");
    }
});


export {
    GetCallSPermissionSlice,
};
